/* eslint-disable global-require */
if (window.location.href.includes('cashout.kassa24.kz')) {
  module.exports = require('./prod');
} else {
  module.exports = require('./dev');
}
